module.exports = __webpack_public_path__ + "static/media/18a-05_Rayos-y-plano-2018-1925x134mm-oleo-sobre-tela.c0ed9da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-05_Rayos-y-plano-2018-1925x134mm-oleo-sobre-tela.jpg
// module id = 223
// module chunks = 0